import get from 'lodash/get';

export function prepareUploadedRows(uploadedRows, matchingCodes) {
  return uploadedRows.map(row => {
    const answers = parseAnswers(row);
    const propCodes = createResponsePropCodesCache(answers);
    const message = readMessage(answers);
    return {propCodes, upload: { message, response: answers }};
  });

  function createResponsePropCodesCache(row){
    return matchingCodes.reduce((acc, code) => {
      acc[code] = trimCode(row[code]);
      return acc;
    }, {});
  }
}

export function findMatchForBid(bid, preparedRows, matchingCodes){
  const codes = getBidCodes(matchingCodes);
  const match = preparedRows.find(row => isMatch(codes, row))
  return match? match.upload : undefined;

  function getBidCodes(){
    return matchingCodes.map(code => ({
      id: code,
      value: trimCode(get(bid, `questionnaire.response.answers.${code}`))
    }));
  }

  function isMatch(cs, row){
    return cs.find(codeDetails => codeDetails.value && codeDetails.value === row.propCodes[codeDetails.id]);
  }
}

function trimCode(code){
  return code ? `${code}`.trim().replace(/^0+/, '') : null;
}

function parseAnswers(row){
  if(!row) return {};
  const keys = Object.keys(row);

  return keys.reduce((acc, key) => {
    const value = row[key];
    if(!(value == null || value === '')){
      acc[key] = value;
    }
    return acc;
  }, {});
}

function readMessage(response){
  if(response.hasOwnProperty('MESSAGE')){
    const message = response.MESSAGE;
    delete response.MESSAGE;
    return message;
  } else {
    return undefined;
  }
}
